import { Action } from 'redux';
import { Page } from '../State';
import { coalesceName } from './index';
import { SET_THEME_NAME, SetThemeNameAction } from './action-creators';
import {
  PAGE_LOAD_CACHED,
  PAGE_LOAD_SUCCESS,
  PageLoadCachedAction,
  PageLoadSuccessAction,
} from '../CurrentPage/action-creators';

export default (state: string, appShellData: Scope.AppShellDataBase, action: Action) => {
  state = coalesceName(state, appShellData.currentTheme);
  switch (action.type) {
    case SET_THEME_NAME: {
      return coalesceName((action as SetThemeNameAction).themeName, state);
    }
    case PAGE_LOAD_CACHED: {
      const pageLoadAction = action as PageLoadCachedAction;
      const cachedItem = pageLoadAction.cachedItem;
      if (cachedItem && typeof cachedItem.currentTheme === 'string') {
        return coalesceName(cachedItem.currentTheme, state);
      }
      return state;
    }
    case PAGE_LOAD_SUCCESS: {
      const pageLoadSuccessAction = action as PageLoadSuccessAction;
      const page = pageLoadSuccessAction.page as Page;
      if (page && typeof page.currentTheme === 'string') {
        return coalesceName(page.currentTheme, state);
      }
      return state;
    }
    default: {
      return state;
    }
  }
};
